import {
  makeReportingDuck,
  ReportingDuckActions,
} from 'ducks/make-reporting-duck';
import { getPaginated, getApi } from 'util/backendapi/fetch';

export const checksheetTemplateListDuck = makeReportingDuck(
  'checksheetTemplate',
  (filters) => getPaginated('/reports/checksheet-templates/', filters),
  () => getApi('/reports/checksheet-templates/info/')
);

export type ChecksheetTemplateListAction = ReportingDuckActions<
  typeof checksheetTemplateListDuck
>;
